__turbopack_context__.v({
  "item": "links-module-scss-module__suSDdG__item",
  "links": "links-module-scss-module__suSDdG__links",
});
